<template>
    <div>
        <div v-for="(layer, layer_index) in clipartLayers" :key="layer._id"
            :class="`column ${layer.layer_width_class}`">
            <div class="clipart-layer mb-2" :style="layer.layer_styles">
                <!--Child rows inside each layer-->
                <div v-for="(row, row_id) in layer.children" :key="`CLIPART_${layer_index}_ROW_${row_id}`"
                    :class="`is-flex mb-2 ${layer.layer_alignment_class}`">
                    <div :style="layer.layer_child_row_styles">
                        <div v-for="(clipart, i) in row.clipart_indexes" :key="`${i}`"
                            @click="clipartBoxClick(layer, layer_index, clipart)"
                            :class="`default-clipart ${layer.apply_border ? 'has-border' : ''} ${$common.clipartImageMargin(layer.image_margin)} ${layer.is_count_tracking || layer.allow_add_remove ? 'hover-allow' : ''}`"
                            :style="`${layer.clipart_resize_type == 'W' &&
                            layer.clipart_width ? 'width:' + layer.clipart_width + 'px;' : ''}${layer.clipart_resize_type == 'H' &&
                                layer.clipart_height ? 'height:' + layer.clipart_height + 'px'
                                : ''
                            }`">
                            <show-image v-if="layer.clipart" :style="clipartImageStylesWidthHeight(layer)"
                                :src="layer.clipart.file" />
                            <show-image
                                v-if="layer.overlay_clipart && layer.overlays && layer.overlays.includes(clipartRowColToNumber(layer, row_id, i))"
                                :style="clipartOverlayImageStyles(layer)" :src="layer.overlay_clipart.file" />
                            <div class="track-box" v-if="layer.is_count_tracking && layer_track_counts[layer_index]">{{
                                layer_track_counts[layer_index][clipart]
                            }}</div>
                        </div>
                    </div>
                </div>

                <div v-if="layer.allow_add_remove" class="column is-12"
                    :style="addRemoveLayerStyles(layer, layer_index)">
                    <div @click="addClipartToPosition(fetchQuestions[fetchCurrentQuestionIndex]._id, layer_index)" class="hover-allow"
                        v-for="img_i in clipartAddRemoveTrackCurrentQuestion(layer_index)"
                        :key="`${layer_index}_${img_i}`"
                        :style="`position: absolute;top:${img_i * 5}px;left:${img_i * 5}px`">
                        <show-image :style="clipartImageStylesWidthHeight(layer)" v-if="layer.clipart"
                            :src="layer.clipart.file" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ShowImage from "@/components/General/ShowImage"
import { mapGetters } from "vuex"
export default {
    name: 'show-clipart-layers',
    components: {
        ShowImage
    },
    props: {
        layers: {
            type: Array,
        }
    },
    data() {
        return {
            clipart_add_remove_track: {},
            layer_track_counts: {}
        }
    },
    computed: {
        ...mapGetters(["fetchQuestions", "fetchCurrentQuestionIndex"]),
        clipartLayers() {
            return this.layers.map(layer => {
                let new_layer = layer
                new_layer['layer_width_class'] = this.$common.clipartLayerWidthClass(layer.layer_width)
                new_layer['layer_styles'] = this.clipartLayerStyles(layer)
                new_layer['layer_alignment_class'] = this.$common.clipartLayerAlignmentClass(layer.alignment)
                new_layer['layer_child_row_styles'] = this.rowStylesForLayer(layer.is_row_group_border, layer.row_styles)
                let children = []

                // Finding the max number of rows/children inside each layer
                const num_children = Math.ceil(layer.number / layer.number_row)
                for (let row_id = 0; row_id < num_children; row_id++) {
                    let clipart_indexes = []

                    // Finding the number of cliparts in each child of layer
                    const num_cliparts = row_id == (num_children - 1) ? layer.number - layer.number_row * (row_id) : layer.number_row

                    for (let i = 0; i < num_cliparts; i++) {
                        clipart_indexes.push(((row_id) * layer.number_row) + i)
                    }

                    children.push({ clipart_indexes })
                }
                new_layer['children'] = children
                return new_layer
            })
        },
    },
    methods: {
        clipartAddRemoveTrackCurrentQuestion(layer_index){
            if(!this.clipart_add_remove_track[this.fetchQuestions[this.fetchCurrentQuestionIndex]._id]) return []

            return this.clipart_add_remove_track[this.fetchQuestions[this.fetchCurrentQuestionIndex]._id][layer_index]
        },
        clipartLayerStyles(layer) {
            let style = {};
            if (layer.is_layer_border) {
                const border_color = layer.layer_border_color
                    ? layer.layer_border_color
                    : "#ccc";
                const border_width = layer.layer_border_width
                    ? layer.layer_border_width
                    : 1;
                style["border"] = `${border_width}px solid ${border_color}`;
            }
            return style;
        },
        rowStylesForLayer(show_border, styles_obj) {
            let styles = {};

            if (show_border && styles_obj) {
                let border_color = styles_obj.border_color
                    ? styles_obj.border_color
                    : "#000";
                let border_width = styles_obj.border_width
                    ? styles_obj.border_width
                    : 1;
                let border_style = `${border_width}px solid ${border_color}`;
                styles["border"] = border_style;
            }

            return styles;
        },
        clipartImageStylesWidthHeight(layer) {
            let styles = {}
            if (layer.clipart_resize_type == 'W' && layer.clipart_width) {
                styles['width'] = layer.clipart_width
            }

            if (layer.clipart_resize_type == 'H' && layer.clipart_height) {
                styles['height'] = `${layer.clipart_height}px!important`
            }

            return styles
        },
        clipartOverlayImageStyles(layer) {
            return {
                ...this.clipartImageStylesWidthHeight(layer),
                position: "absolute",
                left: 0,
                top: 0,
                background: "#ffffff87",
                width: "fit-content"
            }
        },
        addRemoveLayerStyles(layer, layer_index) {
            let styles = {
                'position': 'relative'
            }

            if (layer.clipart_height) {
                styles['height'] = (parseInt(layer.clipart_height) + this.clipart_add_remove_track[layer_index] * 5)
            }

            return styles
        },
        addClipartToPosition(question_id, layer_index) {
            if (this.layers[layer_index].allow_add_remove) {
                // Add the number by 1 to show one more
                this.layers[layer_index].number += 1;
                // Decrease the number of track by 1 to remove from bottom
                this.clipart_add_remove_track[layer_index] -= 1;
            }
        },
        clipartBoxClick(layer, layer_index, clipart_index) {
            const count_step = layer.count_tracking_step
            // If tracking is enabled with overlays
            if (layer.is_count_tracking) {
                this.trackCount(layer_index, clipart_index, count_step);
            }

            // If Images can be added or removed
            if (layer.allow_add_remove) {
                // Subtract the number by 1 to show one less in the current row
                layer.number -= 1;
                // Increase the number of track by 1 to show at bottom
                if (!this.clipart_add_remove_track[layer_index]) this.clipart_add_remove_track[layer_index] = 0;

                this.clipart_add_remove_track[layer_index] += 1;
            }
        },
        trackCount(layer_index, clipart_index, count_step) {
            if (!this.layer_track_counts[layer_index]) this.layer_track_counts[layer_index] = {}

            let layer_obj = JSON.parse(JSON.stringify(this.layer_track_counts[layer_index]));
            //Only if this clipart isnt clicked
            if (!layer_obj[clipart_index]) {
                let layer_keys = Object.keys(layer_obj);
                let count = (layer_keys.length + 1) * count_step;
                layer_obj[clipart_index] = count;
                this.layer_track_counts[layer_index] = layer_obj
            }

            this.layer_track_counts = JSON.parse(JSON.stringify(this.layer_track_counts))
        },
        clipartRowColToNumber(layer, row, col) {
            let position = (row) * layer.number_row + (col + 1);
            return position;
        },
    },
    created() {

    }
}
</script>
<style scoped>
.clipart-layer {
    display: flex;
    flex-direction: column;
    float: left;
}

.track-box {
    width: 100%;
    text-align: center;
    font-size: 28px;
    font-weight: bold;
    background: #5843ff;
    color: #fff;
}
</style>